import { Outlet } from 'react-router-dom'

import Prekindergartengrade_k0_subjects from './prekindergartengrade_k0_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Prekindergartengrade_k0 = ( ) => {
 
  return (
    <>
   
   
  <TopNavbar />
  <Prekindergartengrade_k0_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Prekindergartengrade_k0;